import Vue from 'vue';
import Router from 'vue-router';
import store from '../store'
import constantRoutes from './constantRoutes'
import asyncRoute from './asyncRoute'
import navbar from '@/libs/navbar.json'
Vue.use(Router);
// 剔除的数据
// ,
//             {
//                "icon": "",
//                 "index": "agentList",
//                 "title": "代理人列表"
//             }
let NavBar = JSON.parse(JSON.stringify(navbar))
const createRouter = () => new Router({
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRoutes
})
const router = createRouter()
// 根据权限动态添加
export const initDynamicRouter = () => {
    const type = store.state.user.userInfo.type; // 用户类型
    const routes = router.options.routes;
    const route = routes.find(route => route.name === 'Home')
	console.log("type",type)
    if (type === 'ADMIN') {
        // 动态添加路由
        route.children = [...route.children, ...asyncRoute]
    } else {
        NavBar = [NavBar[0]]
    }
    // 404路由一定得在动态路由中挂载
    routes.push({
        path: '*',
        name: '404',
        component: () => import('../page/notFound')
    })
    store.commit('user/SET_NAVBAR', NavBar)
    router.addRoutes(routes)
}
// 重置路由
/* export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
} */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

let tokenChecked = false;
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;
    const token = sessionStorage.getItem('ms_token');
    if (token) {
        if (to.path === "/login") {
                store.dispatch('user/stopTokenPolling');
                tokenChecked = false; // 避免每次跳转都触发
            next({
                path: "/"
            })
        } else {
            if(!tokenChecked){
                store.dispatch('user/startTokenPolling');
                tokenChecked = true;
            }
            next()
        }
    } else {
        if (to.path === '/login') {
            next()
        } else {
            next({
                path: '/login'
            })
        }
    }
});
export default router